<template>
    <div>
        <b-card no-body class="overflow-hidden" style="">
            <qrcode-stream @decode="on_decode" @init="on_init"></qrcode-stream>
        </b-card>
    </div>
</template>

<script>
    import { QrcodeStream } from 'vue-qrcode-reader'

    export default {
        name: "SimpleScanner",
        props: [],
        components: { QrcodeStream},
        data: function(){
            return {
                result: '',
                error: '',
            }
        },
        methods: {
            on_decode: function(result) {
                if (result){
                    this.$emit("scanCompleted", result);
                }
            },
            async on_init (promise) {
                try {
                    await promise
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                    this.error = "ERROR: you need to grant camera access permisson"
                    } else if (error.name === 'NotFoundError') {
                        this.error = "ERROR: no camera on this device"
                    } else if (error.name === 'NotSupportedError') {
                        this.error = "ERROR: secure context required (HTTPS, localhost)"
                    } else if (error.name === 'NotReadableError') {
                        this.error = "ERROR: is the camera already in use?"
                    } else if (error.name === 'OverconstrainedError') {
                        this.error = "ERROR: installed cameras are not suitable"
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        this.error = "ERROR: Stream API is not supported in this browser"
                    }
                }
            },
        },
        created: function(){}
    }
</script>   


// WEBPACK FOOTER //
// src/components/importables/SimpleScanner.vue